import { apiInstances } from '../../../libs';

const { get } = apiInstances.userInstance;

export default function getPaymentSummary({ service, endDate }) {
  return get(
    `/clouders/payment-summary?service=${service}&end_date=${endDate}`
  );
}
